<ng-container *cbWaitFor="lotMappedItem$$ | async">
    @if (!selectedItem) {
        <cb-working-drawing-search
            [lotMappedItem]="lotMappedItem"
            (workingDrawingSelected)="workingDrawingSelected($event)"
        ></cb-working-drawing-search>
    }
    @if (selectedItem) {
        <cb-working-drawing-view
            [mappedItem]="selectedItem"
            [lotMappedItem]="lotMappedItem"
            (lotMappedItemChange)="lotMappedItemChanged()"
            (goBack)="handleGoBack()"
        ></cb-working-drawing-view>
    }
</ng-container>
